import React, { useState } from "react";
import { WidgetUserMenuNavLinks } from "./WidgetUserMenuNavLinks";
import styles from "./menu-nav-user.module.less";
import { useClickOutside } from "../../hooks";

export function WidgetUserMenuNav({ menuLabel, options }) {
  const ref = useClickOutside(onBlur);

  const [open, setOpen] = useState(false);

  function onBlur() {
    setOpen(false);
  }

  function onAvatarMouseDown() {
    setOpen(!open);
  }

  return (
    <>
      <a
        className={styles["menu-nav-user__avatar"]}
        onMouseDown={onAvatarMouseDown}
      >
        {menuLabel}
      </a>
      {open && (
        <div className={styles["menu-nav-user__popout"]}>
          <span className={styles["menu-nav-user__popout-heading"]}>
            My account
          </span>
          <WidgetUserMenuNavLinks options={options} />
        </div>
      )}
    </>
  );
}
